import { Switch } from 'antd'
import { useTranslation } from 'react-i18next'
import { IScormData } from './../Scorm'
import { Wrapper, SwitchWrapper, SwitchTitle, SwitchSubtitle } from './styled'

interface IProps {
  data: IScormData
  setData: (value: IScormData) => void
}

const Configuration = ({ data, setData }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'administration.blocks.type.scorm'

  return (
    <Wrapper>
      <SwitchWrapper>
        <Switch
          checked={data.showTitle}
          onChange={() => setData({ ...data, showTitle: !data.showTitle })}
        />
        <SwitchTitle>{t(`${translationPrefix}.showTitle.titleV2`)}</SwitchTitle>
      </SwitchWrapper>
      <SwitchWrapper>
        <Switch
          checked={data.openNewWindow}
          onChange={() =>
            setData({ ...data, openNewWindow: !data.openNewWindow })
          }
        />
        <SwitchTitle>
          {t(`${translationPrefix}.openNewWindow.titleV2`)}
        </SwitchTitle>
      </SwitchWrapper>
      <SwitchWrapper>
        <Switch
          checked={data.blockAdvance}
          onChange={() =>
            setData({ ...data, blockAdvance: !data.blockAdvance })
          }
        />
        <SwitchTitle>
          {t(`${translationPrefix}.blockAdvance.title`)}
        </SwitchTitle>
        <SwitchSubtitle>
          {t(`${translationPrefix}.blockAdvance.subtitle`)}
        </SwitchSubtitle>
      </SwitchWrapper>
    </Wrapper>
  )
}

export default Configuration
